import {
    take, call
} from 'redux-saga/effects'
import createNotifications from '@/helpers/notification'
import { integrationVerificationProgressChannel } from './channels'

function* integrationVerificationProgressSaga() {
    const toast = createNotifications()
    const channel = yield call(integrationVerificationProgressChannel)
    while (true) {
        const eventData = yield take(channel)
        console.log('function*integrationVerificationProgressSaga -> eventData', eventData)
        const percent = Math.round(eventData.processedElements / eventData.totalElements * 100)
        toast({
            title: 'Статус верификации',
            type: 'info',
            description: `Процесс верификации интеграции \n"${eventData.integrationName}" \nзавершен на ${percent}%`,
            autoClose: false,
            update: percent > 0,
            toastId: eventData.integrationName
        })
    }
}

export default integrationVerificationProgressSaga